import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AgencyNavbar from '../components/layout/AgencyNavbar';
import AgencyFooter from '../components/layout/AgencyFooter';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const LoginPage = () => {
  const navigate = useNavigate();
  const { loginBusinessAdmin } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    slug: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await loginBusinessAdmin(formData.slug, formData.password);
    setLoading(false);

    if (result.success) {
      toast.success('¡Bienvenido!');
      navigate('/admin');
    } else {
      toast.error(result.error || 'Credenciales incorrectas');
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <AgencyNavbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-md mx-auto">
          <div className="bg-[#1C1C1C] border border-[#333333] rounded-lg p-8">
            <div className="text-center mb-8">
              <LogIn className="w-16 h-16 mx-auto mb-4 text-[#E9FF60]" />
              <h1 
                className="text-3xl font-black mb-2"
                style={{ fontFamily: 'Unbounded, Montserrat, sans-serif' }}
                data-testid="login-title"
              >
                <span className="text-[#E9FF60]">INICIAR</span> SESIÓN
              </h1>
              <p className="text-gray-400">Accede al panel de administración de tu negocio</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-300">
                  Slug de tu Negocio
                </label>
                <Input
                  type="text"
                  value={formData.slug}
                  onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
                  placeholder="ej: mi-negocio"
                  required
                  className="bg-black border-[#333333] text-white focus:border-[#E9FF60]"
                  data-testid="login-slug"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Este es el identificador único de tu negocio en la URL
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2 text-gray-300">
                  Contraseña
                </label>
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  placeholder="••••••••"
                  required
                  className="bg-black border-[#333333] text-white focus:border-[#E9FF60]"
                  data-testid="login-password"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-[#E9FF60] hover:bg-[#f0ff80] text-black font-bold py-3 text-lg"
                data-testid="login-submit"
              >
                {loading ? 'Iniciando sesión...' : 'Ingresar al Panel'}
              </Button>
            </form>

            <div className="mt-6 pt-6 border-t border-[#333333] text-center">
              <p className="text-sm text-gray-400 mb-2">¿No tienes una cuenta?</p>
              <a
                href="/demo"
                className="text-[#E9FF60] hover:underline text-sm font-semibold"
              >
                Solicita una demo →
              </a>
            </div>

            <div className="mt-4 text-center">
              <p className="text-xs text-gray-500">
                ¿Olvidaste tu contraseña?{' '}
                <a
                  href="mailto:mispedidosapp@gmail.com"
                  className="text-[#E9FF60] hover:underline"
                >
                  Contáctanos
                </a>
              </p>
            </div>
          </div>

          {/* Demo Credentials Info */}
          <div className="mt-6 bg-[#262626] border border-[#333333] rounded-lg p-4">
            <p className="text-sm text-gray-400 mb-2">
              <span className="text-[#E9FF60] font-semibold">💡 Cuentas Demo:</span>
            </p>
            <ul className="text-xs text-gray-500 space-y-1">
              <li>• Slug: <code className="text-[#E9FF60]">demo-burger</code> / Pass: <code>demo123</code></li>
              <li>• Slug: <code className="text-[#E9FF60]">demo-pizza</code> / Pass: <code>demo123</code></li>
              <li>• Slug: <code className="text-[#E9FF60]">demo-sushi</code> / Pass: <code>demo123</code></li>
            </ul>
          </div>
        </div>
      </div>

      <AgencyFooter />
    </div>
  );
};

export default LoginPage;
